import React from 'react'
export default function dynamic<T>(
    loader: () => Promise<any>,
    _options?: { ssr?: boolean; loading?: () => React.ReactElement | null }
) {
    return React.lazy(() =>
        loader().then((result: any) => {
            // React.lazy requires { default: Component }
            // Some callers resolve to the component directly (e.g. .then(r => r.MapContainer))
            if (result && typeof result === 'object' && 'default' in result) {
                return result
            }
            return { default: result }
        })
    )
}
